import React, {Fragment, useState, useMemo, useCallback, useEffect} from "react";
import Breadcrumb from "../../common/breadcrumb/breadcrumb";
import DataTable from "react-data-table-component";
import Calendar from "react-calendar";
import {
  Container,
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";
import moment from 'moment';
//import { MoreHorizontal } from "react-feather";
import {Database, ShoppingBag, MessageCircle, UserPlus, MoreHorizontal, Video, Users} from "react-feather";
import dashboard from './dashboardutils';
import {sessions} from "../../../api/sessions";
import {utenti} from "../../../api/users";
import differenceBy from "lodash/differenceBy";
import {toast} from "react-toastify";
import './dashboard.scss'
import {IconTooltip} from "../../common/iconTooltip/IconTooltip";
import {HasPermission} from "react-role-permission";

const Default = (props) => {
  const columns = [
    {
      name: "Tipo",
      selector: "tipo",
      sortable: true,
      center: true,
      width: '10%',
      default: 'Video',
      format: (row) => {
        return (
          <img
            className="img-100 img-fluid m-r-20"
            src='/images/video_icon_sm.png'
            alt=""
          />
        )
      },
    },
    {
      name: "Nome",
      selector: "name",
      sortable: true,
      center: true,
      className: "default-text mb-0 f-w-700 f-18",
      style: 'color: var(--primary-color);font-weight: 700;font-size: 14px;',
      width: '25%'

    },

    // {
    //   name: "Gruppo",
    //   selector: "gruppo",
    //   sortable: true,
    //   center: true,
    //   format : (row) => {
    //     return (<span class="badge badge-pill recent-badge f-12">{row.gruppo}</span>)
    //   },
    //   width:'15%'
    // },

    {
      name: "Data evento",
      selector: "timestamp",
      sortable: true,
      center: true,
      width: '20%',
      format: (row) => {
        return moment(new Date(row.timestamp)).format('DD/MM/YYYY h:mm:ss')

      }
    },


    {
      name: "Azioni",
      selector: "id",
      sortable: true,
      center: true,
      format: (row) => {
        return (
          <div className="actions-container">
            <IconTooltip
              icon={'icon-eye'}
              id={row.id}
              link={`/sessions/view?id=${row.id}`}
              tooltipMessage={'Guarda'}
              className={'btn-primary'}
            />
            &nbsp;
            {HasPermission('/sessions/manage') && <IconTooltip
              icon={'icofont icofont-video-clapper'}
              id={row.id}
              link={`/sessions/manage?id=${row.id}`}
              tooltipMessage={'Gestisci'}
              className={'btn-warning'}
            />}
            &nbsp;
            {HasPermission('/sessions/add') && <IconTooltip
              icon={'icon-pencil'}
              id={row.id}
              link={`/sessions/add?id=${row.id}`}
              tooltipMessage={'Modifica'}
              className={'btn-secondary'}
            />}
          </div>

        )
      },
    },
  ];

  // eslint-disable-next-line
  const [date, setDate] = useState(new Date());

  const [modal, setModal] = useState(false);

  const [nextsession, setNextSession] = useState({name: '', timestamp: '', stato: ''});
  const [lastsession, setLastSession] = useState({name: '', timestamp: '', stato: ''});
  const [sessionList, setSessionList] = useState([]);
  const [numutenti, setNumUtenti] = useState('');
  const [selectedRows, setSelectedRows] = useState([]);
  const [toggleCleared, setToggleCleared] = useState(false);
  const [data, setData] = useState(sessionList);

  const [loading, setLoading] = useState(true);

  const handleRowSelected = useCallback((state) => {
    setSelectedRows(state.selectedRows);
  }, []);

  const contextActions = useMemo(() => {
    const handleDelete = () => {
      if (
        window.confirm(
          `Are you sure you want to delete:\r ${selectedRows.map(
            (r) => r.name
          )}?`
        )
      ) {
        setToggleCleared(!toggleCleared);
        setData(differenceBy(data, selectedRows, "name"));
        toast.success("Successfully Deleted !");
      }
    };

    return (
      <Button
        key="delete"
        onClick={handleDelete}
        style={{backgroundColor: "red"}}
      >
        Delete
      </Button>
    );
  }, [data, selectedRows, toggleCleared]);

  const toggle = () => {
    // setModal(!modal);
    localStorage.setItem("isUser", null);
  };
  const onChange = (date) => {
    setDate(date);
    //todo restore later if needed
    // if (window.confirm('Crea sessione al ' + date)) {
    //   window.location.href = '/sessions/add?date=' + date.getTime();
    // }

  }


  const getNextLastSessions = (descorderedsessionlist) => {
    const currdate = new Date();
    const olderSessions = [];
    const result = {'next': 0, 'last': 0};
    for (var i = 0; i < descorderedsessionlist.length; i++) {
      const sessionedate = new Date(descorderedsessionlist[i].timestamp);
      if (currdate < sessionedate) {
        result.next = descorderedsessionlist[i];
      } else if (currdate > sessionedate) {
        olderSessions.push(descorderedsessionlist[i])
      }
    }
    if (olderSessions.length > 0) {
      result.last = olderSessions[0]
    }
    return result;
  }

  useEffect(async () => {
    setLoading(true);
    // if (localStorage.getItem("isUser") === "true") {
    //   setModal(true);
    // } else {
    //   setModal(false);
    // }

    try {
      const listaSessioni = await sessions.methods.getList();
      let listasessionisorted = listaSessioni.sort(function (a, b) {
        return new Date(b.timestamp) - new Date(a.timestamp);
      })
      setSessionList(listasessionisorted);
      if (listasessionisorted?.length > 0) {
        const nextlast = getNextLastSessions(listasessionisorted);
        setNextSession(nextlast.next);
        setLastSession(nextlast.last);
      } else {
        setNextSession({name: 'Prossima Sessione', timestamp: '--/--/-- --:--', stato: '-'});
        setLastSession({name: 'Ultima Sessione', timestamp: '--/--/-- --:--', stato: '-'});
      }

      const listaUtenti = await utenti.methods.loadUtenti();
      if (listaUtenti && listaUtenti.length > 0) setNumUtenti(listaUtenti.length);


    } catch (e) {
      toast.error(
        "Si è verificato un errore"
      );
    }


    setLoading(false);

  }, []);

  // localStorage.setItem("layout_version", "dark-only");
  // localStorage.setItem("layout_version", "light");
  //toggle();
  return (
    <Fragment>
      <Breadcrumb parent="Dashboard" title="Progetto Streaming"/>
      <Container fluid={true}>
        <Row>
          <Col lg="12 xl-100">
            <Row>
              <Col xl="3 xl-50" md="6 box-col-6">
                <Card className="gradient-primary o-hidden" style={{minHeight: '18vh'}}>
                  <CardBody className="b-r-4">

                    <div className="media static-top-widget">
                      <div className="align-self-center text-center">
                        <Video/>
                      </div>
                      <div className="media-body">
                        <span className="m-0 text-white"><b>Prossima Sessione:</b> </span>
                        <h4
                          className="mb-0 counter">{nextsession.name}</h4>
                        <h6
                          className="mb-0 counter text-white">{Number.isInteger(nextsession.timestamp) ? moment(new Date(nextsession.timestamp)).format('DD/MM/YYYY hh:mm') : nextsession.timestamp}</h6>
                        <Video className="icon-bg"/>
                        <div
                          className={`spinner-border Typeahead-spinner ${
                            loading === true ? "show" : ""
                          }`}
                          role="status"
                        >
                        </div>
                      </div>
                    </div>

                  </CardBody>
                </Card>
              </Col>
              <Col xl="3 xl-50" md="6 box-col-6">
                <Card className="gradient-secondary o-hidden" style={{minHeight: '18vh'}}>
                  <CardBody className="b-r-4">
                    <div className="media static-top-widget">
                      <div className="align-self-center text-center">
                        <Video/>
                      </div>
                      <div className="media-body">
                        <span className="m-0 text-white"><b>Ultima Sessione: </b></span>
                        <h4
                          className="mb-0 counter">{lastsession.name}</h4>
                        <h6
                          className="mb-0 counter text-white">{Number.isInteger(lastsession.timestamp) ? moment(new Date(lastsession.timestamp)).format('DD/MM/YYYY hh:mm') : lastsession.timestamp}</h6>
                        <Video className="icon-bg"/>
                        <div
                          className={`spinner-border Typeahead-spinner ${
                            loading === true ? "show" : ""
                          }`}
                          role="status"
                        >
                        </div>
                      </div>
                    </div>
                  </CardBody>
                </Card>
              </Col>
              <Col xl="3 xl-50" md="6 box-col-6">
                <Card className="gradient-warning o-hidden" style={{minHeight: '18vh'}}>
                  <CardBody className="b-r-4">
                    <div className="media static-top-widget">
                      <div className="align-self-center text-center text-white">
                        <Users/>
                      </div>
                      <div className="media-body">
                        <span className="m-0 text-white"><b>Totale Utenti</b></span>
                        <h4 className="mb-0 counter text-white">{numutenti}</h4>
                        <h6 className="mb-0 counter text-white">&nbsp;</h6>

                        <Users className="icon-bg"/>
                        <div
                          className={`spinner-border Typeahead-spinner ${
                            loading === true ? "show" : ""
                          }`}
                          role="status"
                        >
                        </div>
                      </div>
                    </div>
                  </CardBody>
                </Card>
              </Col>
              <Col xl="3 xl-50" md="6 box-col-6">
                <Card className="gradient-info o-hidden" style={{minHeight: '18vh'}}>
                  <CardBody className="b-r-4">
                    <div className="media static-top-widget">
                      <div className="align-self-center text-center text-white">
                        <Users/>
                      </div>
                      <div className="media-body">
                        <span className="m-0 text-white"><b>Totale Recorders</b></span>
                        <h4 className="mb-0 counter text-white">0</h4>
                        <h6 className="mb-0 counter text-white">&nbsp;</h6>
                        <Users className="icon-bg"/>
                        <div
                          className={`spinner-border Typeahead-spinner ${
                            loading === true ? "show" : ""
                          }`}
                          role="status"
                        >
                        </div>
                      </div>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Col>


          {(<Col xl="8 xl-100 box-col-12">
            <Card>
              <CardHeader className="no-border">
                <h5>Ultime Sessioni</h5>
                <ul className="creative-dots">
                  <li className="bg-primary big-dot"></li>
                  <li className="bg-secondary semi-big-dot"></li>
                  <li className="bg-warning medium-dot"></li>
                  <li className="bg-info semi-medium-dot"></li>
                  <li className="bg-secondary semi-small-dot"></li>
                  <li className="bg-primary small-dot"></li>
                </ul>
                {/* <div className="card-header-right">
                  <ul className="list-unstyled card-option">
                    <li>
                      <i className="icofont icofont-gear fa fa-spin font-primary"></i>
                    </li>
                  </ul>
                </div> */}
              </CardHeader>
              <CardBody className="pt-0">

                <div className="activity-table table-responsive recent-table ">
                  <DataTable
                    columns={columns}
                    data={sessionList.filter((s, ix) => ix < 10)}
                    striped={true}
                    center={true}
                    className="table-xs table table-styling"
                    style={{
                      marginTop: "0px",
                      maxWidth: "100%",
                      overflow: 'auto',
                      width: '100%',
                      position: 'relative',
                      top: '-55px'
                    }}
                  />


                </div>
              </CardBody>
            </Card>
          </Col>  
          )}
          {(<Col xl="4 xl-100 box-col-12">
            <Card className="gradient-primary o-hidden">
              <CardBody>
                <div className="default-datepicker">
                  <div
                    className="datepicker-here"
                    data-language="en"
                    style={{margin: "0 auto"}}
                  >
                    <Calendar onChange={onChange}/>
                  </div>
                </div>
                <span className="default-dots-stay overview-dots full-width-dots">
                  <span className="dots-group">
                    <span className="dots dots1"></span>
                    <span className="dots dots2 dot-small"></span>
                    <span className="dots dots3 dot-small"></span>
                    <span className="dots dots4 dot-medium"></span>
                    <span className="dots dots5 dot-small"></span>
                    <span className="dots dots6 dot-small"></span>
                    <span className="dots dots7 dot-small-semi"></span>
                    <span className="dots dots8 dot-small-semi"></span>
                    <span className="dots dots9 dot-small"> </span>
                  </span>
                </span>
              </CardBody>
            </Card>
          </Col>
          )}

        </Row>
        <Modal isOpen={modal} className="welcome-popup modal-dialog-centered">
          <button
            onClick={toggle}
            className="close"
            type="button"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <ModalBody>
            <ModalHeader></ModalHeader>
            <div className="contain p-30">
              <div className="text-center">
                <h3>Streaming Portal</h3>
                <p>v.1.0 </p>
                <button
                  onClick={toggle}
                  className="btn btn-primary btn-lg txt-white"
                  type="button"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  Avanti
                </button>
              </div>
            </div>
          </ModalBody>
        </Modal>
      </Container>
    </Fragment>
  );
};

export default Default;
